import { Cohort, Color } from 'root-constants'

export const MENU_BG_COLORS: Record<Cohort, string> = {
  [Cohort.VARIANT_ONE]: Color.DARK,
  [Cohort.VARIANT_TWO]:
    'linear-gradient(172.27deg, #141931 29.45%, #1F107D 70.83%, #69B7FF 100%), #13182A',
}
